module.exports = "## Compress JPEG and PNG Images Without Losing Quality\r\n\r\nOptimize your images to reduce file size while keeping image quality"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoCompress/photo-compress-header.md
// module id = 1154
// module chunks = 0